/**
 * 導師諮詢 — 繁體中文（嵌套結構，對應 t('chat.…')）
 */
export default {
	meta: {
		title: "導師諮詢 - 先知命局",
		keywords: "導師諮詢,線上諮詢,命理諮詢",
		description: "與認證導師一對一線上諮詢，獲得專業命理與人生指引。",
	},
	breadcrumb: {
		home: "首頁",
		current: "導師諮詢",
	},
	chatList: {
		title: "聊天列表",
		searchPlaceholder: "搜尋導師名稱",
		inService: "服務中...",
		empty: "暫無匹配結果",
	},
	chatRoom: {
		viewHome: "查看主頁",
		serviceOrder: "服務下單",
		saySomething: "說點什麼",
		highServiceCountdown: "溫馨提示: 您的咨詢服務倒計時",
		continueConsult: "繼續咨詢",
		freeChatCountdown: "溫馨提示: 15分鐘內無限次數自由問服務倒計時",
		sendRecommend: "發送",
		sendAria: "發送",
		loading: "加載中...",
		noMessages: "暫無聊天記錄",
		loadMore: "點擊或下拉加載更多",
		noMoreData: "沒有更多數據啦~",
		serviceEndsAt: "服務{date}結束",
		pleaseInput: "請輸入",
		pleaseInputFollowUp: "請一次性輸入追問內容",
		freeChatUsedUp: "今日免費聊天次數已用完",
		freeChatRemaining: "今日免費聊天剩{count}句",
		quote: "引用",
		recall: "撤回",
		quoteImage: "[圖片]",
		quoteAudio: "[音頻]",
		emptyMessageError: "不能發送空消息",
	},
	service: {
		consultService: "諮詢服務",
		fahuiService: "法會服務",
		noData: "暫無數據",
		originalPrice: "原價{price}點數",
		finalPriceLabel: "到手價",
		orderNow: "立即下單",
	},
	recommendTeachers: {
		ariaLabel: "推薦更多導師",
		title: "推薦更多導師",
		loading: "加載中...",
		empty: "暫無推薦導師",
		prevNav: "上一組導師",
		nextNav: "下一組導師",
		avatarAlt: "老師頭像",
		defaultName: "老師",
		defaultSummary: "全能導師，用戶滿意度 99%",
		defaultTags: ["戀愛情感", "婚姻挽回"],
		viewDetail: "查看詳情",
		consultNow: "立即諮詢",
	},
	message: {
		notSupport: "網頁端暫不支持查看此消息，請前往App查看",
		goToApp: "請前往App查看",
		downloadAppForMore: "請下載App查看更多",
		goToAppOperate: "請前往App內操作",
		recommendServiceTitle: "老師為您推薦一個服務",
		originalPrice: "原價 {price}銅幣",
		orderNow: "立即下單",
		serviceOrder: "服務下單",
		inviteReward: "老師邀請你打賞",
		rewardNow: "立即打賞",
		payOrder: "支付訂單",
		rewardTeacher: "打賞老師",
		rewardDesc: "感謝您的支持和信任，可以打賞一定的金額作為心意。",
		actualPayment: "實付金額:",
		insufficientPoints: "點數不足",
		paying: "支付中...",
		confirmPay: "確認支付",
		generatingOrder: "正在生成訂單...",
		tipTeacher: "打賞老師",
		remark: "備註：",
		teacherCardDesc: "老師名片",
		yearsExperience: "從業{year}年",
		orderTime: "下單時間：",
		evaluated: "已評價",
		notEvaluated: "未評價",
		coupon: "優惠券",
		discount: "折",
		couponGift: "{name}老師送你一張【{couponName}】",
		noThresholdCoupon: "無門檻優惠券",
		minSpendCoupon: "滿{amount}可用",
		usageRange: "使用範圍：",
		validUntil: "有效期至：",
		sending: "發送中",
		serviceCompleted: "{serviceName}服務已完成",
		normalQuestion: "普通問題",
		premiumService: "高級服務",
	},
};
